import {Icon} from '../../types/icons/icon.type';
import {SVG_ICON_PATH} from '../../constants/image-paths.constants';

export function iconToIconPath(icon: Icon): string {
    return SVG_ICON_PATH + '/' + icon + '.svg';
}